import styled from '@emotion/styled';
import { css } from '@emotion/core';
import {
	BaseCell,
	BaseHeader,
} from '../../../flights/overview/ui/list/columns/Column';
import { DownloadIcon, Responsive } from '../../../../ui';
import { IAsset } from '../../../../contentful/types/IAsset';
import { Color } from '../../../../styles/Color';

interface IPolicyDownloadCellProps {
	asset: IAsset;
	title: string;
}

const styles = css`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	width: 60px;
	max-width: 60px;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		max-width: none;
	}
`;

const StyledHeader = styled(BaseHeader)`
	${styles}
`;

const StyledCell = styled(BaseCell)`
	${styles}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		grid-area: download;
	}
`;

const DownloadLink = styled.a`
	display: flex;
	align-items: center;
	color: ${Color.OnBackground};

	&:hover {
		opacity: 0.7;
	}
`;

export function Header() {
	return <StyledHeader />;
}

export function Cell({ asset, title }: IPolicyDownloadCellProps) {
	return (
		<StyledCell>
			<DownloadLink
				href={asset.fields.file.url}
				target="_blank"
				rel="noopener noreferrer"
				aria-label={`Download ${title}`}
				download
			>
				<DownloadIcon />
			</DownloadLink>
		</StyledCell>
	);
}
